import React from 'react';
import * as Sentry from '@sentry/react';

export default (props: { children: any }) => (
    <Sentry.ErrorBoundary fallback={<div>Noget gik galt!</div>}>
        {props.children}
    </Sentry.ErrorBoundary>
);
